import { ResourceKey } from "i18next";

export const CompanyPage: ResourceKey = {
    award: "gunning",
    bid: "offerte",
    company_information_section_title: "Bedrijfsinformatie",
    competitors: "Concurrenten",
    buyers: "Kopers",
    suppliers: "Leveranciers",
    copied_to_clipboard_title_1: 'Tekst "',
    copied_to_clipboard_title_: '" gekopieerd naar het klembord',
    direct_competitor_title_1: "Directe concurrent in",
    direct_competitor_title_2: "aanbestedingen",
    shared_projects_title_1:"Gunningen",
    shared_projects_title_2:"van bovenstaand bedrijf",
	win_ratio_title_1: "Winst ratio",
	win_ratio_title_2: "in overheidsopdrachten",
	experience_graph_type_tenders_won: "Gewonnen Aanbestedingen",
	experience_graph_type_bids_won: "Gewonnen Offertes",
	experience_title_2_tenders_won: "Geen gegevens over gewonnen aanbestedingen voor vergelijking",
	graphLabel: {
		bids: 'Offertes',
		wins: 'Winsten',
		date: 'Datum',
		value: 'Waarde',
		bid: 'Bod',
		tenders_won: "Gewonnen Aanbestedingen",
	},
    follow_company: "Volg dit bedrijf: hou me op de hoogte wanneer dit bedrijf deelneemt aan een overheidsopdracht en geef een overzicht in het gunningstabblad",
    followed_company: "Gevolgd bedrijf: ",
    main_activities_section_title: "Soorten overheidsopdrachten",
    main_buyers_section_title: "Belangrijkste kopers",
    projects_contracted_title_1: "Gegunde opdrachten",
    projects_contracted_title_2: "aan boverstaand bedrijf",
    recent_activity_section_title: "Recente overheidsopdrachten",
    recently_participated_in_section_title: "Deelgenomen",
    contracted_open_section_title: "Openstaande opdrachten",
    contracted_closed_section_title: "Afgesloten opdrachten",
    recently_won_section_title: "Gewonnen",
    shared_projects_title: "Gedeelde projecten",
    company_experience_title: "Ervaring",
    show_company_page: "Toon bedrijfspagina",
    tendering: "Tendering",
    tenders_contracted_closed_title: "Recent uitgeschreven tenders",
    tenders_contracted_open_title: "Openstaande tenders",
    unknown_company: "Ongekend bedrijf",
    company_info_details_title: "Details",
    company_info_contact_title: "Contact",
    company_info_activities_title: "Activiteiten",
    company_info_accreditations_title: "Erkenningen",
    company_info_start_date_title: "Startdatum",
    price: "Prijs",
    quality: "Kwaliteit",
    balanced: "Hybride",
    orientation: "Focus",
    priceOriented: "Prijsgericht",
    qualityOriented: "Kwaliteitsgericht",
    averageLotValue: "Omvang",
    verySmallScale: "Zeer klein",
    smallScale: "Klein",
    mediumScale: "Middel groot",
    largeScale: "Groot",
    veryLargeScale: "Zeer groot",
    government_category_title: "Zoek naar overheden",
    company_category_title: "Zoek naar bedrijven",
    offers_and_awards_title: "PVs & Gunningen",
    frameworks_title: "Aflopende contracten",
    has_tender_experience: "Actief in overheidsopdrachten",
    lot_value_title_2: "in overheidsopdrachten",
    win_ratio_increase: "stijging vs vorig jaar",
    win_ratio_decrease: "daling vs vorig jaar",
    win_ratio_no_change: "geen verandering vs vorig jaar",
    lot_value_increase: "stijging vs vorig jaar",
    lot_value_decrease: "daling vs vorig jaar",
    lot_value_no_change: "geen verandering vs vorig jaar",
    experience_tenders_won_increase: "stijging vs vorig jaar",
    experience_tenders_won_decrease: "daling vs vorig jaar",
    experience_tenders_won_no_change: "geen verandering vs vorig jaar",
    orientation_increase_price: "meer prijsfocus vs vorig jaar",
    orientation_decrease_price: "minder prijsfocus vs vorig jaar",
    orientation_no_change: "zelfde prijsfocus vs vorig jaar",
    bidStatus: {
        won: "Gewonnen",
        lost: "Verloren",
        not_known: "Onbekend",
    },
    lotValueLabel: "Waarde van het lot",
    tenders_plural: "aanbestedingen",
    win_ratio_graph_type: "Winstpercentage",
    lot_value_graph_type_scatter: "Lotwaarden",
    orientation_graph_type: "Oriëntatie",

    // Add new tooltip translations
    orientationTooltip: {
        priceFocus: "Prijsfocus",
        priceCount: "Winsten (Prijs)", // Using 'Winsten' (Wins) for consistency
        qualityCount: "Winsten (Kwaliteit)", // Using 'Winsten' (Wins) for consistency
    },

    // Tooltips for WinRateGraph (NL)
    winrateGraph: {
        tooltipExpand: "Klik om details te tonen",
        tooltipCollapse: "Klik om samenvatting te tonen",
    },

    statistics_tab_title: "Kerncijfers",
};
